import React, { useEffect, useState } from "react";
import BotHeader from "../schemesBot/BotHeader";
import StatCard from "./StatCard";
import Arrow from "../../assets/icons/arrow.png";
import Download from "../../assets/icons/download.png";
import Msg from "../../assets/icons/msg.png";
import Telephone from "../../assets/icons/telephone.png";
import Time from "../../assets/icons/time.png";
import User from "../../assets/icons/user.png";
import User2 from "../../assets/icons/user2.png";
// import Loading from "../../assets/gif/loader.gif";
import Graph from "./Graph";
import axios from "axios";
import { KPI_URL } from "../../utils/constants";
import PieChart from "./PieCharts";
import BarCharts from "./BarCharts";

const Dashboard = () => {
  const [kpiData, setKpiData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(KPI_URL, {
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("access_token"),
          },
        });
        setKpiData(response?.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching KPI data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="border-gray border-y-2 border-r-2 w-[100%] sm:w-[100%] relative h-full overflow-y-auto shadow-md bg-white">
      {loading && (
        <div className="w-full h-full flex items-center justify-center">
          {/* <img src={Loading} alt="Loading..." className="w-auto h-10vh" /> */}
        </div>
      )}
      {kpiData && (
        <div className="bg-white ">
          <div className=" relative w-full h-auto overflow-y-auto bg-cover bg-center z-0">
            <div className="flex flex-col h-auto sm:h-[40%]">
              <div className="flex flex-col sm:flex-row sm:h-[50%] gap-4 sm:gap-[4%] px-[15%] sm:px-[3%] pt-5">
                <div className="w-full sm:flex-1">
                  <StatCard
                    about="Total User Sessions"
                    count={kpiData.user_sessions?.count}
                    icon={User}
                    colorCode={1}
                  />
                </div>
                <div className="w-full sm:flex-1">
                  <StatCard
                    about="Total Queries Answered"
                    count={kpiData.queries_answered?.count}
                    icon={Msg}
                    colorCode={2}
                  />
                </div>
                <div className="w-full sm:flex-1">
                  <StatCard
                    about="Total App Downloads"
                    count={272}
                    status={`100% vs Last Month`}
                    icon={Download}
                    colorCode={3}
                  />
                </div>
                <div className="w-full sm:flex-1">
                  <StatCard
                    about="Average Response Time"
                    count={`${kpiData.avg_res_time?.count}s`}
                    icon={Time}
                    colorCode={4}
                  />
                </div>
              </div>
              <div className="flex flex-col sm:flex-row sm:h-[50%] gap-4 sm:gap-[4%] px-[15%] pt-5">
                <div className="w-full sm:flex-1">
                  <StatCard
                    about="⁠Monthly Active Users"
                    count={kpiData.sessions_this_month?.count}
                    status={`${kpiData.sessions_this_month?.percentage}% vs Last Month`}
                    icon={User2}
                    colorCode={5}
                  />
                </div>
                <div className="w-full sm:flex-1">
                  <StatCard
                    about="Daily Active Users"
                    count={kpiData.sessions_today?.count}
                    status={`${kpiData.sessions_today?.percentage}% vs Yesterday`}
                    icon={Arrow}
                    colorCode={6}
                  />
                </div>
                <div className="w-full sm:flex-1">
                  <StatCard
                    about="Tele-Law Conversations"
                    count={kpiData.tele_law?.count}
                    status={`${kpiData.tele_law?.percentage}% vs Last Month`}
                    icon={Telephone}
                    colorCode={7}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-auto h-[300px] sm:h-[55vh] border-2 border-gray-200 rounded-xl pt-2 pr-2 sm:p-4 m-4">
            <Graph
              data={kpiData.usage_trend}
              title=" ⁠Usage Trend Analysis (Active Users & Queries over time)"
            />
          </div>
          <div className="flex flex-col sm:flex-row sm:h-[50vh] gap-4  m-4 ">
            <div className="flex w-full sm:w-[50%] h-[350px] sm:h-full border-2 border-gray-200 rounded-xl pt-2 pr-2 ">
              <PieChart
                data={kpiData.lang_used}
                nameKey="lang"
                title="User Languages Used for Queries"
                colors={["#6366F1", "#10B981", "#F59E0B", "#EC4899", "#8B5CF6"]}
              />
            </div>
            <div className="flex w-full sm:w-[50%] h-[350px] sm:h-full border-2 border-gray-200 rounded-xl pt-2 pr-2 ">
              <PieChart
                data={kpiData.query_mode}
                nameKey="type"
                title="Query Mode Distribution"
                innerRadius={60}
                colors={["#6366F1", "#10B981"]}
              />
            </div>
          </div>
          <div className="flex flex-col sm:flex-row  sm:h-[55vh] gap-4 m-4">
            <div className="flex w-full sm:w-[50%] h-[300px] sm:h-full border-2 border-gray-200 rounded-xl pt-2 pr-2 ">
              <BarCharts
                data={kpiData.legal_category}
                nameKey="category"
                title="Top Legal Categories Queried"
                xAxisName="Number of Queries"
                colors={["#6366F1", "#10B981", "#F59E0B", "#EC4899", "#8B5CF6"]}
              />
            </div>
            <div className="flex w-full sm:w-[50%] h-[300px] sm:h-full  border-2 border-gray-200 rounded-xl pt-2 pr-2 ">
              <BarCharts
                data={kpiData.query_distribution}
                nameKey="time"
                title="Query Distribution - Peak Hours"
                xAxisName="Queries"
                colors={["#10B981"]}
              />
            </div>
          </div>
          <div className="flex  gap-4 sm:gap-2  m-4">
            <div className="flex w-full h-[300px] sm:h-[60vh] border-2 border-gray-200 rounded-xl pt-2 pr-2 ">
              <BarCharts
                data={kpiData.users_by_state}
                nameKey="state"
                title="Geographic Reach - Users by State"
                xAxisName="Active Users"
                colors={[
                  "#027FEC",
                  "#7FBEF5",
                  "#9FC9FF",
                  "#C6DEFD",
                  "#C6DEFD",
                  "#CDE6FC",
                  "#CAE6FF",
                ]}
                horizontal={true}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
